import { useEffect } from 'react'
import React from 'react'
import { useDispatch, useSelector } from '../../../store'
import { LoadingLogo, PlanType } from '@labrav/react-components'
import { useStyles } from './DetailsView.styles'
import { UsagePlansView } from './UsagePlansView/UsagePlansView'
import {
  CombinedFormDimension,
  CombinedFormState,
} from '../../../modules/combinedForm/reducer'
import { getProducts } from '../../../modules/productsListing/action'
import { PlansView } from './PlansView/PlansView'
import StatusHeader from './StatusHeader/StatusHeader'
import OfferDetails from './OfferDetails/OfferDetails'
import PricingView from './PricingView/PricingView'
import { getCurrencySymbol } from '../../../common/utils/getCurrencySymbol'
import ContractDetails from './ContractDetails/ContractDetails'
import EulaDetails from './EulaDetails/EulaDetails'
import { CircularProgress } from '@mui/material'
import { LoadingTypes, isLoading as Loading } from '@labrav/common'

interface DetailsViewProps {
  isImpartner?: boolean
}

const CombinedFormDetailsAWS: React.FC<DetailsViewProps> = ({
  isImpartner = false,
}) => {
  const dispatch = useDispatch()

  const queryParams = new URLSearchParams(location.search)
  const viewingPersona = queryParams.get('viewing_persona') || ('CP' as string)
  const { classes } = useStyles()
  const combinedFormData = useSelector<CombinedFormState>(
    state => state.combinedFormInCreation || ({} as CombinedFormState)
  )
  const accountId = combinedFormData?.labraIsvId
  const isLoadingGeneral = useSelector<boolean>(state =>
    Loading(state.loading)(LoadingTypes.FETCH_PRODUCTS)
  )
  const isLoadingProducts = useSelector<boolean>(state =>
    Loading(state.loading)(LoadingTypes.COMBINED_FORM_LOADING)
  )
  useEffect(() => {
    if (accountId) {
      dispatch(getProducts(accountId, 'AWS'))
    }
  }, [accountId, dispatch])

  const productType = combinedFormData.resellerAgreementData.productType

  const dimensions = (combinedFormData?.resellerAgreementData.dimensions ||
    []) as CombinedFormDimension[]
  const filterdDimensions = dimensions.filter(dimension =>
    productType !== PlanType.SAAS_SUBSCRIPTION
      ? dimension.type === 'additional_usage'
      : true
  )
  const filterdStandardDims = dimensions.filter(dim => dim.type === 'standard')
  if (isLoadingGeneral || isLoadingProducts) {
    return isImpartner ? (
      <div className={classes.loadingContainer}>
        <CircularProgress size={30} />
      </div>
    ) : (
      <LoadingLogo />
    )
  }

  const currencySymbol =
    getCurrencySymbol(
      combinedFormData?.resellerAgreementData.currency as string
    ) || '$'
  return (
    <div className={classes.combinedFormRoot}>
      <StatusHeader
        combinedFormData={combinedFormData}
        viewingPersona={viewingPersona}
      />
      <OfferDetails
        combinedFormData={combinedFormData}
        viewingPersona={viewingPersona}
      />
      {combinedFormData.resellerAgreementData.productType ===
      'SAAS_CONTRACT' ? (
        <ContractDetails combinedFormData={combinedFormData} />
      ) : (
        ''
      )}
      {productType !== PlanType.SAAS_SUBSCRIPTION && (
        <>
          {filterdStandardDims.length > 0 && (
            <PlansView combinedFormData={combinedFormData} />
          )}
          <PricingView
            combinedFormData={combinedFormData}
            currencySymbol={currencySymbol}
            viewingPersona={viewingPersona}
          />
        </>
      )}
      {filterdDimensions.length > 0 && (
        <UsagePlansView
          combinedFormData={combinedFormData}
          viewingPersona={viewingPersona}
          productType={productType as PlanType}
        />
      )}
      <EulaDetails
        combinedFormData={combinedFormData}
        viewingPersona={viewingPersona}
      />
    </div>
  )
}

export default CombinedFormDetailsAWS
